<script>
import AuthMixins from '@/mixins/AuthMixins';
import ls from 'localstorage-slim'
import algoliasearch from 'algoliasearch';

export default {
	name: 'RecommendedOrgs',

	mixins: [AuthMixins],

  data() {
		return {
			key: 'escRecommendedOrgs',
			forcedFresh: false, // Set this to true to ensure it fetches fresh data on every page load.
			preferences: false,

			query: '',
			client: false,
			index: false,
			index_name: (this.$config.test_env) ? 'orgs-2023-test' : 'orgs-2023-live',
			searchObject: {
				hitsPerPage: 10,
				facets: [],
				facetFilters: [],
				numericFilters: []
			},
		}
	},

	mounted() {
		console.log("Recommended Orgs Knows who is logged in", this.me);

		this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
		this.index = this.client.initIndex(this.index_name);

		// If we have nothing stored in localstorage, fetch some new recommendations from Algolia based on the user preferences.
		if (this.recommended_orgs === null || this.forcedFresh) {
      this.setRecommended({
        index: 0,
        orgs: []
      });
			this.preferences = (this.me !== undefined) ? _.cloneDeep(this.me.preferences) : false;
			console.log("Performing Preferences Search for Recommended Orgs", this.preferences);
			this.performPreferenceSearch();
    } else {
			if (this.recommended_org === false) {
				let objectID = this.recommended_orgs.orgs[0].objectID;
				this.recommended_org = this.recommended_orgs.orgs[0]
			}
			this.emitter.emit('refresh:recommended:orgs', this.recommended_orgs.orgs);
		}
  },

	methods: {
		getRecommended() {
      return ls.get(this.key);
    },
    setRecommended(value) {
      return ls.set(this.key, value, { ttl: 60*60*24 });
    },
		performPreferenceSearch() {
			this.searchObject.facetFilters = [];
			this.searchObject.numericFilters = [];
			delete this.searchObject.aroundLatLng;
			delete this.searchObject.aroundRadius;

			if (this.preferences) {
				// benefit
				// Unknown Search

				// cause
				// Unknown Search

				// industry
				if (this.preferences.industry !== null && this.preferences.industry.length > 0) {
					let options = [];
					this.preferences.industry.forEach((pref) => {
						options.push("industry:"+pref);
					});
					this.searchObject.facetFilters.push(options);
				}

				// level
				// N/A

				// location
				if (this.preferences.location !== null && this.preferences.location.indexOf(",") > 0) {
					this.searchObject.aroundLatLng = this.preferences.location;
					this.searchObject.aroundRadius = 25000; // 25Km
				}

				// remote
				if (this.preferences.remote !== null && this.preferences.remote.length > 0) {
					let options = [];
					this.preferences.remote.forEach((pref) => {
						options.push("remote:"+pref);
					});
					this.searchObject.facetFilters.push(options);
				}

				// role
				// N/A

				// salary
				// N/A

				// size
				if (this.preferences.size !== null && this.preferences.size.length > 0) {
					let options = [];
					this.preferences.size.forEach((pref) => {
						options.push("size:"+pref);
					});
					this.searchObject.facetFilters.push(options);
				}

				// wow
				// Unknown Search

			}

			console.log('facetFilters', this.searchObject.facetFilters);

			this.index
			.search(this.query, this.searchObject)
			.then((results) => {
				if (results.nbHits > 2) {
					console.log("Recommended org hits:", results.hits, results.nbHits);
					let orgs = results.hits;
					this.setRecommended({
						'index': 0,
						'orgs': orgs
					});
					this.recommended_org = results.hits[0];
					this.emitter.emit('refresh:recommended:orgs', orgs);
				} else {
					this.recommended_org = false;
					this.expandSearchCriteria();
				}
			});
		},
		expandSearchCriteria() {
			let skip = false;
			if (this.preferences.industry !== null && skip == false) {
				this.preferences.industry = null
				skip = true;
				console.log("Dropped `Industry` from Search Critera");
			}
			if (this.preferences.location !== null && skip == false) {
				this.preferences.location = null
				skip = true;
				console.log("Dropped `Location` from Search Critera");
			}
			if (this.preferences.remote !== null && skip == false) {
				this.preferences.remote = null
				skip = true;
				console.log("Dropped `Remote` from Search Critera");
			}
			if (this.preferences.size !== null && skip == false) {
				this.preferences.size = null
				skip = true;
				console.log("Dropped `Size` from Search Critera");
			}
			this.performPreferenceSearch();
		},
		performObjectSearch(objectID) {
			this.searchObject.facetFilters = [["published:true"],["objectID:"+objectID]];
			this.searchObject.hitsPerPage = 1;
			this.index
			.search(this.query, this.searchObject)
			.then((results) => {
				console.log("we got our recommended org:", results.hits, results.nbHits);
				if (results.nbHits > 0) {
					this.recommended_org = results.hits[0];
				} else {
					this.recommended_org = false;
				}
			});
		},

	},

	computed: {
		hasRecommendations() {
      return this.getRecommended() === null ? false : true;
    },
		recommended_orgs() {
			return this.getRecommended();
		}
	}
}
</script>
